
// import Vue from 'vue'

export default {
  name: 'IdCardIcon',
}
